import { Link } from 'react-router-dom';
import Logo from './Logo';
import { categories } from '@/mocks/articles';

const socialLinks = [
  { icon: 'ri-wechat-line', label: '微信' },
  { icon: 'ri-weibo-line', label: '微博' },
  { icon: 'ri-bilibili-line', label: '哔哩哔哩' },
  { icon: 'ri-youtube-line', label: '视频号' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-background-50 text-primary-700 flex items-center justify-center font-heading text-lg font-bold">
                鲁
              </span>
              <span className="font-heading text-lg font-bold text-background-50">鲁啊鲁</span>
            </Link>
            <p className="text-sm leading-relaxed text-primary-100/80">
              鲁啊鲁是面向广泛互联网用户的多元内容平台，涵盖时事、科技、生活、文化与娱乐等领域，并提供活跃的社区交流空间。
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">
              <Link to="/" className="hover:text-accent-300 transition-colors">快速导航</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-primary-100/80">
              <li><Link to="/" className="hover:text-background-50 transition-colors">首页</Link></li>
              <li><Link to="/community" className="hover:text-background-50 transition-colors">社区交流</Link></li>
              <li><Link to="/favorites" className="hover:text-background-50 transition-colors">我的收藏</Link></li>
              <li><Link to="/about" className="hover:text-background-50 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">
              <Link to="/" className="hover:text-accent-300 transition-colors">内容分类</Link>
            </h4>
            <ul className="space-y-2.5 text-sm text-primary-100/80">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link to={`/category/${cat.key}`} className="hover:text-background-50 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold text-background-50">关注我们</h4>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-primary-100 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={`${item.icon} text-lg`}></i>
                </span>
              ))}
            </div>
            <p className="mt-4 text-xs leading-relaxed text-primary-100/60">
              本站内容均为虚构示范数据，仅用于产品演示。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-100/70">
          <p>© 2026 鲁啊鲁 · 多元内容资讯与社区互动平台 · 保留所有权利</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="hover:text-background-50 transition-colors">使用说明</Link>
            <Link to="/about" className="hover:text-background-50 transition-colors">隐私声明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}